import { wrapReducer } from "@client/content/lib/helper";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { sort } from "@common/lib/array";
import { Actions, type InitSuccessActionData } from "./actions";
import { type PackagePricing } from "./types";

const reducer = (state: PackagePricing.AppState, action: ReduxAction<any>): PackagePricing.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const data = action.data as InitSuccessActionData;
      return {
        ...state,
        ...data,
        tiers: data.tiers
          ? {
              contacts: sort(data.tiers.contacts, { key: "startValue" }),
              staff: sort(data.tiers.staff, { key: "startValue" })
            }
          : null,
        status: Status.Ready
      };
    }
    default:
      return state;
  }
};

export const defaultState: PackagePricing.AppState = {
  id: "",
  package: null,
  status: Status.None,
  tiers: null,
  trial: null,
  trialPagePath: ""
};
export const previewState: PackagePricing.AppState = {
  ...defaultState,
  status: Status.Ready
};
export default wrapReducer({ defaultState, reducer, previewState });
